export const storeProducts = [
  {
    id: 1,
    title: "Galaxy A50",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1582603045/imgs_starwars/EcommerceProject/SAMSUNGa50_swnxeh.png",
    price: 300,
    company: "Samsung",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "smartPhones",
    date: "12/29/2019",
  },
  {
    id: 6,
    title: "Galaxy Note 10+",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1582602667/imgs_starwars/EcommerceProject/SAMSUNGNOTE10_jbvxjr.png",
    price: 1500,
    company: "Samsung",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "smartPhones",
    date: "12/29/2019",
  },
  {
    id: 3,
    title: "Moto One",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1582602953/imgs_starwars/EcommerceProject/MOTOROLA_o4ybcb.png",
    price: 809,
    company: "Motorola",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "smartPhones",
    date: "12/29/2019",
  },
  {
    id: 4,
    title: "Nokia - 9 PureView",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1582602878/imgs_starwars/EcommerceProject/NOKIAPHONE_w0soxn.png",
    price: 508,
    company: "Nokia",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "smartPhones",
    date: "12/29/2019",
  },
  {
    id: 5,
    title: "Pixel 4 XL",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1582602755/imgs_starwars/EcommerceProject/GOOGLEPIXEL4_vi2kjv.png",
    price: 650,
    company: "Google",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "smartPhones",
    date: "12/29/2019",
  },
  {
    id: 2,
    title: "G8X ThinQ",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1582602584/imgs_starwars/EcommerceProject/LGDUAL_dpmhmw.png",
    price: 600,
    company: "LG",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "smartPhones",
    date: "12/29/2019",
  },
  {
    id: 7,
    title: "iPhone 8",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1582603136/imgs_starwars/EcommerceProject/iphone8white_xiu8fl.png",
    price: 399,
    company: "apple",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "smartPhones",
    date: "12/29/2019",
  },
  {
    id: 8,
    title: "iPhone 10",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581284570/imgs_starwars/EcommerceProject/iPhone10_muhe0f.png",
    price: 499,
    company: "apple",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "smartPhones",
    date: "12/29/2019",
  },
  {
    id: 9,
    title: "iPhone 11",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581284572/imgs_starwars/EcommerceProject/iPhone11_cjko3v.png",
    price: 1099,
    company: "apple",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "smartPhones",
    date: "12/29/2019",
  },
  {
    id: 10,
    title: "Galaxy Fold",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581284572/imgs_starwars/EcommerceProject/galaxyFold_mq0l5q.png",
    price: 1098,
    company: "Samsung",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "smartPhones",
    date: "12/29/2019",
  },
  {
    id: 11,
    title: "ALIENWARE M17",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581284146/imgs_starwars/EcommerceProject/ALIEANWARE17_gcti3b.png",
    price: 2622,
    company: "ALIENWARE",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "laptops",
    date: "12/29/2019",
  },
  {
    id: 12,
    title: "ALIENWARE M15",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581284147/imgs_starwars/EcommerceProject/alianware15_aydkjb.png",
    price: 2022,
    company: "ALIENWARE",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "laptops",
    date: "12/29/2019",
  },
  {
    id: 13,
    title: "Razer Blade 15",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581284147/imgs_starwars/EcommerceProject/razerblade_g4aqat.png",
    price: 3168,
    company: "Razer",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "laptops",
    date: "12/29/2019",
  },
  {
    id: 14,
    title: "MacBook Pro 16",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581284146/imgs_starwars/EcommerceProject/macbook16_htxlhe.png",
    price: 6099,
    company: "Apple",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "laptops",
    date: "12/29/2019",
  },
  {
    id: 15,
    title: " MacBook Pro 15",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581284147/imgs_starwars/EcommerceProject/macbookpro15_djnbjo.png",
    price: 3099,
    company: "Apple",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "laptops",
    date: "12/29/2019",
  },
  {
    id: 16,
    title: "AsusXVP 15 ",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581284146/imgs_starwars/EcommerceProject/asuslaptop_ddwdch.png",
    price: 2999,
    company: "Asus",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "laptops",
    date: "12/29/2019",
  },
  {
    id: 17,
    title: "ThinkPad P1 15",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581284145/imgs_starwars/EcommerceProject/lenevoThinkpad_ggwyfi.png",
    price: 2999,
    company: "Lenovo",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "laptops",
    date: "12/29/2019",
  },
  {
    id: 18,
    title: "Pixelbook 12.3",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581284145/imgs_starwars/EcommerceProject/googleChrome_igbj6t.png",
    price: 1650,
    company: "Google",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "laptops",
    date: "12/29/2019",
  },
  {
    id: 19,
    title: "Surface Studio 2",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581284145/imgs_starwars/EcommerceProject/microsoftSurface_mepmud.png",
    price: 2999,
    company: "Microsoft",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "laptops",
    date: "12/29/2019",
  },
  {
    id: 20,
    title: "ROG Swift 27",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581284145/imgs_starwars/EcommerceProject/asusMonitor_t1hfik.png",
    price: 599,
    company: "ASUS",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "monitors",
    date: "12/29/2019",
  },
  {
    id: 21,
    title: "UltraWide 27",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581284145/imgs_starwars/EcommerceProject/lgcurved_wdxw3z.png",
    price: 1099,
    company: "LG",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "monitors",
    date: "12/29/2019",
  },
  {
    id: 22,
    title: "CHG9 Series 49",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581284145/imgs_starwars/EcommerceProject/samsung_fytjbq.png",
    price: 1099,
    company: "Samsung",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "monitors",
    date: "12/29/2019",
  },
  {
    id: 23,
    title: "27 IPS LED 4K",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581287066/imgs_starwars/EcommerceProject/AcerMonitor_zprrsi.png",
    price: 1499,
    company: "Acer",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "monitors",
    date: "12/29/2019",
  },
  {
    id: 24,
    title: "Beats Studio Wireless Gray",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1582603447/imgs_starwars/EcommerceProject/beatsGray_wlkdox.png",
    price: 349,
    company: "Beats by Dr. Dre",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "headphones",
    date: "12/29/2019",
  },
  {
    id: 25,
    title: "Beats Studio Wireless White",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1582603463/imgs_starwars/EcommerceProject/beatsWhite_hzixmw.png",
    price: 349,
    company: "Beats by Dr. Dre",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "headphones",
    date: "12/29/2019",
  },
  {
    id: 26,
    title: "Beats Studio Wireless Red",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1582603589/imgs_starwars/EcommerceProject/beatsRed_ocuhko.png",
    price: 349,
    company: "Beats by Dr. Dre",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "headphones",
    date: "12/29/2019",
  },
  {
    id: 27,
    title: "Noise Cancelling 700 Black",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1582603745/imgs_starwars/EcommerceProject/boseBlack_ntuzax.png",
    price: 399,
    company: "Bose",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "headphones",
    date: "12/29/2019",
  },
  {
    id: 28,
    title: "Noise Cancelling 700 White",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1582603833/imgs_starwars/EcommerceProject/bosewhite_qbpust.png",
    price: 399,
    company: "Bose",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "headphones",
    date: "12/29/2019",
  },
  {
    id: 29,
    title: "AirPods Pro - White",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1582604109/imgs_starwars/EcommerceProject/airpodes_ejhpad.png",
    price: 249,
    company: "Apple",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "headphones",
    date: "12/29/2019",
  },
  {
    id: 30,
    title: "Powerbeats Pro Navy",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1582604192/imgs_starwars/EcommerceProject/powerbeats_vb6t96.png",
    price: 249,
    company: "Beats by Dr. Dre",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "headphones",
    date: "12/29/2019",
  },

  {
    id: 31,
    title: "Samsung QLED - 82 Class",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1590422721/imgs_starwars/EcommerceProject/QLEDSamSumg_imtyu4.png",
    price: 5995,
    company: "Samsung",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "tvs",
    date: "12/29/2019",
  },

  {
    id: 32,
    title: "Sony X950G - 85 Class",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1590422721/imgs_starwars/EcommerceProject/Sony84Class_jnuptq.png",
    price: 4995,
    company: "Sony",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "tvs",
    date: "12/29/2019",
  },

  {
    id: 33,
    title: "LG UM6970- 75 Class",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1590422721/imgs_starwars/EcommerceProject/lg75class_uyubgo.png",
    price: 1995,
    company: "LG",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "tvs",
    date: "12/29/2019",
  },

  {
    id: 34,
    title: "DynaTAC 8000X",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1582951015/imgs_starwars/EcommerceProject/firstcellphone_wjlvle.png",
    price: 3995,
    company: "Motorola",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "retro",
    date: "12/29/2019",
  },
];

export const detailProduct = [
  {
    id: 25,
    title: "Iphone 11",
    img:
      "https://res.cloudinary.com/duprwuo4j/image/upload/v1581284572/imgs_starwars/EcommerceProject/iPhone11_cjko3v.png",
    price: 1099,
    company: "apple",
    info:
      "Stay at the top of your game with this once in a life time product. NVIDIA G-SYNC technology eliminates screen tearing and stuttering for smooth gameplay, while the 178-degree viewing angle delivers crisp, bright pictures from almost any direction. This product has an ergonomic stand with tilt, swivel, and height adjustment settings for a customized setup, and the 4K resolution offers sharp visuals.",
    inCart: false,
    count: 0,
    total: 0,
    category: "smartPhones",
    date: "12/29/2019",
  },
];
